import { BaseQueryFn, EndpointBuilder } from "@reduxjs/toolkit/query";
import { withLoaderAndSideEffects, withOnQueryStarted } from "./withOnQueryStareted";
import { retryFetch } from "./retryFetch";

const createQuery = (builder: EndpointBuilder<BaseQueryFn, never, 'baseApi'>, responseHandler: (response: any, api: any, arg: any) => void) => {
    return builder.query<any, { baseURL: string; params?: Record<string, any> }>({
        queryFn: withLoaderAndSideEffects(async (arg: { baseURL: string; params?: Record<string, any> }, _api: BaseQueryFn, _extra: unknown, fetch: (args: any) => Promise<any>) => {
            const { baseURL, params } = arg;

            console.log('[createQuery] Called with:', { baseURL, params });

            // Build URL with query params if provided
            let url = baseURL;
            console.log('[createQuery] Building URL with params:', params);
            if (params && Object.keys(params).length > 0) {
                const searchParams = new URLSearchParams();
                Object.entries(params).forEach(([key, value]) => {
                    if (value !== undefined && value !== null) {
                        searchParams.append(key, String(value));
                    }
                });
                const queryString = searchParams.toString();
                if (queryString) {
                    url = `${baseURL}?${queryString}`;
                }
            }
            console.log('[createQuery] Final URL:', url);
            console.log('[createQuery] Final URL:', url);

            const response = await retryFetch(
                async () =>
                    fetch({
                        url: url,
                        method: 'GET',
                    })
            );

            // fetchBaseQuery already wraps successful responses as { data: ... }
            // The response here is already { data: actual_response_body }
            console.log('[Query] Response from fetch:', {
                hasData: !!response?.data,
                dataType: typeof response?.data,
                dataIsArray: Array.isArray(response?.data)
            });

            if (responseHandler) responseHandler(response, _api, arg);

            // RTK Query expects { data: ... } structure
            // Since fetch already returns { data: ... }, just return it as-is
            return response;
        }),
        onQueryStarted: withOnQueryStarted()
    });
};

export default createQuery;